export const initialState = {
    asideFilters: [],
    customText: '',
    enabled: true,
    dashboardLocked: false,
    filterWidget: null,
    goalsUpdated: null,
    handles: [],
    hasCRMMetrics: false,
    images: [],
    leftAsideMenusOpen: [],
    leftAsideOpen: false,
    modalPickerShowClear: true,
    modalPickerShowClearCount: 10,
    pickerFilters: [],
    prismMenu: 'Home',
    prismMenuStats: {},
    prismMultiColumn: true,
    rightAsideOpen: false,
    rightAsideTab: '',
    exploreAsideOpen: false,
    filterAsideOpen: false,
    saving: false,
    showFormHelp: true,
    showSuccess: false,
    tags: [],
    text: [],
    teamPage: ['TEAM', 'COACHING', 'PERFORM', 'RATIOS', 'ACTIVITY'],
    videoPosition: 0,
    videoTime: 0,
};
